import script from "./ContractsImportPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractsImportPanel.vue?vue&type=script&setup=true&lang=js"

import "./ContractsImportPanel.vue?vue&type=style&index=0&id=38228b12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38228b12"]])

export default __exports__